import { render } from "./App.vue?vue&type=template&id=6c5de548"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6c5de548&lang=css"

import exportComponent from "D:\\_\\node\\work\\muso-ninjas\\node_modules\\.pnpm\\vue-loader@17.0.1_u4ryg6e3aznhweo4gilim5qufe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__